export default "__VITE_ASSET__CyCr6XCZ__"